import CsharpEnum from "@/_helpers/CsharpEnum";
import Enum from "@/_helpers/Enum.js";
import i18n from "@/plugins/i18n.js";

export default {
  types: [
    {
      name: i18n.t("module.enum.types.0"),
      value: CsharpEnum.ModuleType.MULTICHART,
      icon: "mdi-chart-areaspline",
    },
    {
      name: i18n.t("module.enum.types.14"),
      value: CsharpEnum.ModuleType.TRENDCHART,
      icon: "mdi-chart-bar-stacked",
    },
    {
      name: i18n.t("module.enum.types.1"),
      value: CsharpEnum.ModuleType.GAUGE,
      icon: "mdi-gauge",
    },
    {
      name: i18n.t("module.enum.types.16"),
      value: CsharpEnum.ModuleType.TILTCHART,
      icon: "mdi-rotate-orbit",
    },
    {
      name: i18n.t("module.enum.types.8"),
      value: CsharpEnum.ModuleType.SINGLE,
      icon: "mdi-counter",
    },
    {
      name: i18n.t("module.enum.types.2"),
      value: CsharpEnum.ModuleType.TEXT,
      icon: "mdi-card-text",
    },
    {
      name: i18n.t("module.enum.types.4"),
      value: CsharpEnum.ModuleType.MAP,
      icon: "mdi-map-marker-multiple",
    },
    {
      name: i18n.t("module.enum.types.11"),
      value: CsharpEnum.ModuleType.IMAGEMAP,
      icon: "mdi-home-map-marker",
    },
    {
      name: i18n.t("module.enum.types.3"),
      value: CsharpEnum.ModuleType.IMAGE,
      icon: "mdi-image",
    },
    {
      name: i18n.t("module.enum.types.6"),
      value: CsharpEnum.ModuleType.IFRAME,
      icon: "mdi-iframe",
    },
    {
      name: i18n.t("module.enum.types.7"),
      value: CsharpEnum.ModuleType.WEATHER,
      icon: "mdi-weather-cloudy",
    },
    {
      name: i18n.t("module.enum.types.9"),
      value: CsharpEnum.ModuleType.RAWTABLE,
      icon: "mdi-table-of-contents",
    },
    {
      name: i18n.t("module.enum.types.12"),
      value: CsharpEnum.ModuleType.FUNCTIONBUTTON,
      icon: "mdi-language-javascript",
    },
    {
      name: i18n.t("module.enum.types.13"),
      value: CsharpEnum.ModuleType.INFOCARD,
      icon: "mdi-information",
    },
    {
      name: i18n.t("module.enum.types.15"),
      value: CsharpEnum.ModuleType.SENSOROVERVIEW,
      icon: "mdi-leak",
    },
  ],

  methods: {
    getDefaultSizeForWidget(type) {
      return {
        sm: Enum.SizeForType[type].sm[0].value,
        md: Enum.SizeForType[type].md[0].value,
      };
    },

    isInType(t, types) {
      if (typeof types != "object" && types.length < 0) return false;

      return types.includes(t);
    },
  },

  computed: {
    ModuleTypes() {
      return CsharpEnum.ModuleType;
    },
  },
};
